import P1 from "../img/p1.jpg"
import P2 from "../img/p2.jpg"
import P3 from "../img/p3.jpg"
import P4 from "../img/p4.jpg"
import P5 from "../img/p5.jpg"
import P6 from "../img/p6.jpg"
import P7 from "../img/p7.jpg"
import P8 from "../img/p8.jpg"
import P9 from "../img/p9.png"
import P10 from "../img/p10.png"
import P11 from "../img/p11.jfif"
import P12 from "../img/p12.jpg"




const ProjectImages =[
    {
        Id: 1,
        imgSrc: P1,
        text: "Booklist App",
        href: "https://github.com/rjrishika/booklist-app"
    },
    {
        Id: 2,
        imgSrc: P2,
        text: "Drawing App",
        href: "https://github.com/rjrishika/drawing-app"
    },
    {
        Id: 3,
        imgSrc: P3,
        text: " Quiz App",
        href: "https://github.com/rjrishika/quiz-app"
    },
    {
        Id: 4,
        imgSrc: P4,
        text: "Recipe App",
        href: "https://github.com/rjrishika/recipe-app"
    },
    {
        Id: 5,
        imgSrc: P5,
        text: "Snake Game",
        href: "https://github.com/rjrishika/snake-game"
    },
    {
        Id: 6,
        imgSrc: P6,
        text: "Todo App",
        href: "https://github.com/rjrishika/todo-app"
    },   
    {
        Id: 12,
        imgSrc: P12,
        text: "Corona Tracker",
        href: "https://github.com/rjrishika/corona-tracker",
        web: "https://rjcoronatracker.netlify.app/"
    },   

    {
        Id: 7,
        imgSrc: P7,
        text: "Movie App",
        href: "https://github.com/rjrishika/movie-app"
    },   
    {
        Id: 8,
        imgSrc: P8,
        text: "Chat App",
        href: "https://github.com/rjrishika/react-chat-app"
    },
    {
        Id: 9,
        imgSrc: P9,
        text: "Feedback",
        href: "https://github.com/rjrishika/feedbackapp"
    },
    {
        Id: 10,
        imgSrc: P10,
        text: "Github Finder",
        href: "https://github.com/rjrishika/githubfinder",
        web: 'https://rgithubfinder.netlify.app/'
    },
    {
        Id: 11,
        imgSrc: P11,
        text: "Travel Advisor",
        href: "https://github.com/rjrishika/traveladvisor",
        web: "https://travel-advisor-rj.netlify.app/"
    },
    
]

export {ProjectImages}